export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/paper/precinct/info/query`,
          data
        });
      },
      getInfo(data) {
          return http.json({
              url: `/paper/precinct/info/get?id=${data.id}`
          })
      },
      save(data) {
          return http.json({
              url: `/paper/precinct/info/saveInfo`,
              data
          })
      },
      remove(data) {
          return http.json({
              url: `/paper/precinct/info/removeById?id=${data[0].id}`,
              data
          })
      },
      getPaperInfos(data) {
        return http.json({
            url: `/paper/info/list`,
            data
        })
    },

    treeBuild(data) {
        return http.json({
            url: `/paper/precinct/info/treeBuild?name=${data.name}`,
            data
        })
    },
        /**
         * 发布
         * @param data
         * @return {*}
         */
         publish(data) {
            return http.json({
                url: `/paper/precinct/info/publish`,
                data
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        unPublish(data) {
            return http.json({
                url: `/paper/precinct/info/unPublish?id=${data}`,
                data
            })
        },
        pushNotification(data) {
            return http.json({
                url: `paper/precinct/info/pushNotification/?isAnswer=0&paperPrecinctInfoId=${data}`,
                data
            })
        },
      /**
       * 问卷手动推送
       * @param data
       * @return {*}
       */
      pushNotifications(data) {
          return http.json({
              url: `paper/precinct/info/pushNotifications/?isAnswer=0&paperPrecinctInfoId=${data.id}`,
              data
          })
      },

      queryByCode(data) {
          return http.json({
              url: `/system/dict/e/${data.code}`,
              data
          });
      },

      xscHouseResultExport(data) {
          return http.json({
              url: `/paper/precinct/info/xscHouseResultExport`,
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/precinct_info.js